import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Pulse from "../Loader/Pulse";
import { GetCookie } from "../../exports/CookieManagement";
import { getDeviceSize } from "../../exports/InteractiveUtils";
import Search from "../../assets/icons/search.svg";

const DEVICE_SIZE = getDeviceSize();

const HighLightText = ({ text, query, customClass }) => {
  const parts = text.split(new RegExp(`(${query})`, "gi"));
  return (
    <span title={text}>
      {" "}
      {parts.map((part, i) => (
        <span
          key={i}
          className={
            part.toLowerCase() === query.toLowerCase() ? `${customClass}` : ""
          }
        >
          {part.toUpperCase()}
        </span>
      ))}{" "}
    </span>
  );
};

function StockSuggestion({
  search,
  loading,
  history,
  suggestions,
  ClearSearchBox,
  handleSelect,
}) {
  const navigate = useNavigate();

  function OpenSymbol(symbol) {
    handleSelect(symbol);
    ClearSearchBox();
  }
  if (suggestions === undefined) {
    suggestions = [];
  }

  if (loading) {
    return (
      <div className="search__loader">
        <Pulse />
        {/* <span>Loading Mutual Funds Please Wait ...</span> */}
      </div>
    );
  }

  if (Array.isArray(suggestions) && suggestions.length > 0) {
    return (
      <>
        {suggestions.map((s, index) => {
          return DEVICE_SIZE === "S" ? (
            <>
              <div
                className="search__item"
                key={`${s.ISIN}-${s.Scheme_Type}-${index}`}
                onClick={() => {
                  OpenSymbol(s);
                }}
              >
                <div>
                  <span>{s.ISIN}</span>
                  <span>{s.Scheme_Type}</span>
                </div>
                <span>{s.Scheme_Name}</span>
              </div>
            </>
          ) : (
            <>
              <p
                key={`${s.ISIN}-${s.Scheme_Type}-${index}`}
                onClick={() => {
                  OpenSymbol(s);
                }}
              >
                <HighLightText
                  text={s.Scheme_Name}
                  query={search}
                  customClass="search__highlight"
                />

                <span className="search__separator">
                  <span>{s.ISIN}</span><span>{s.Scheme_Type}</span>
                </span>
              </p>
            </>
          );
        })}
      </>
    );
  } else {
    return (
      <div className="search__loader">
        {search.length === 0 ? (
          <>
            <Pulse />
            <span>No recent searches</span>
            <span>Hit Me...</span>
          </>
        ) : (
          <span>
            No result for &nbsp;<strong>'{search.toUpperCase()}'</strong>
          </span>
        )}
      </div>
    );
  }
}

const MFSearch = ({ handleSelect }) => {
  const ref = useRef(null);
  const abortControllerRef = useRef();

  const [search, setSearch] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [suggestionOpen, setSuggestionOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestion] = useState(undefined);

  const REQUEST_BASE_URL = process.env.REACT_APP_REQUEST_BASE_URL;

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const account_token = GetCookie("token");

  const filterMutualFunds = (data, searchQuery) => {
    if (!searchQuery || searchQuery.trim() === "") {
      return [];
    }

    const query = searchQuery.toLowerCase().trim();

    return data.filter((f) => {
      const schemeName = f.Scheme_Name?.toLowerCase() || "";
      const schemeWords = schemeName.split(/\s+/);
      const queryWords = query.toLowerCase().trim().split(/\s+/); 

      const schemeMatches = queryWords.every((q) =>
        schemeWords.some((w) => w.startsWith(q))
      );

      return schemeMatches;
    });
  };

  useEffect(() => {
    setLoading(true);
    search.length === 0 ? setSuggestionOpen(false) : setSuggestionOpen(true);

    async function GetStockSuggestions() {
      try {
        if (abortControllerRef.current) {
          abortControllerRef.current.abort();
        }

        abortControllerRef.current = new AbortController();
        const signal = abortControllerRef.current.signal;

        if (search === "") {
          return [];
        }

        const response = await fetch(
          `${REQUEST_BASE_URL}/mf/search/${search}?token=${account_token}`,
          {
            signal,
          }
        );
        const data = await response.json();
        if (data.data && Array.isArray(data.data)) {
          return filterMutualFunds(data.data, search);
        } else {
          return [];
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    }

    const triggerAPICall = setTimeout(async () => {
      const data = await GetStockSuggestions();
      setSuggestion(data);
      setLoading(false);
    }, 500);

    return () => {
      clearTimeout(triggerAPICall);
      setSuggestion(undefined);
    };
  }, [search]);

  function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      setSuggestionOpen(false);
      setSearch("");
      setSuggestion(undefined);
    }
  }

  function ClearSearchBox() {
    setSearch("");
    setSuggestion([]);
    setSuggestionOpen(false);
  }

  return (
    <div className="stock__search__icons__wrapper">
      <div className="stock__search" ref={ref}>
        <div className="stock__search__icon">
            <img src={Search} alt="" />
          </div>
        <input
          placeholder="Search mutual funds"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {suggestionOpen && (
          <>
            <div className="stock__suggestions">
              <div className="suggestion__stocks">
                <StockSuggestion
                  search={search}
                  loading={loading}
                  handleSelect={handleSelect}
                  suggestions={suggestions}
                  ClearSearchBox={ClearSearchBox}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MFSearch;
